'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _classAutobindDecorator = require('class-autobind-decorator');

var _classAutobindDecorator2 = _interopRequireDefault(_classAutobindDecorator);

var _mightyFields = require('../../../lib/mighty-fields');

var _FieldSets = require('./FieldSets');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default.signature : function (a) {
  return a;
};

var NewMedicalApplicationModal = (_dec = (0, _mobxReact.inject)('UiStore', 'ApplicationStore', 'FunderStore'), _dec(_class = (0, _classAutobindDecorator2.default)(_class = (0, _mobxReact.observer)(_class = (_temp = _class2 = function (_Component) {
  _inherits(NewMedicalApplicationModal, _Component);

  function NewMedicalApplicationModal() {
    _classCallCheck(this, NewMedicalApplicationModal);

    return _possibleConstructorReturn(this, (NewMedicalApplicationModal.__proto__ || Object.getPrototypeOf(NewMedicalApplicationModal)).apply(this, arguments));
  }

  _createClass(NewMedicalApplicationModal, [{
    key: 'onSave',
    value: function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(formData) {
        var _props, _case, ApplicationStore, formattedData;

        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _props = this.props, _case = _props._case, ApplicationStore = _props.ApplicationStore, formattedData = {
                  case: _case.id,
                  is_available_to_coop: formData.is_available_to_coop,
                  lien: _extends({}, formData, { case: _case.id })
                };
                _context.next = 3;
                return ApplicationStore.createMedical(formattedData);

              case 3:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function onSave(_x) {
        return _ref.apply(this, arguments);
      }

      return onSave;
    }()
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          UiStore = _props2.UiStore,
          _props2$FunderStore = _props2.FunderStore,
          isMedicalProvider = _props2$FunderStore.isMedicalProvider,
          isFinanceCustomer = _props2$FunderStore.isFinanceCustomer;


      return _react2.default.createElement(_mightyFields.FormModal, {
        fieldSets: (0, _FieldSets.fieldSetsMedicalApplication)({ isFinanceCustomer: isFinanceCustomer, isMedicalProvider: isMedicalProvider }),
        onClose: UiStore.modals.NewMedicalApplication.close,
        onSave: this.onSave,
        title: 'New Medical Funding Application'
      });
    }
  }, {
    key: '__reactstandin__regenerateByEval',
    // @ts-ignore
    value: function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);

  return NewMedicalApplicationModal;
}(_react.Component), _class2.propTypes = {
  _case: _propTypes2.default.object.isRequired,
  ApplicationStore: _propTypes2.default.object.isRequired,
  FunderStore: _propTypes2.default.object.isRequired,
  UiStore: _propTypes2.default.object.isRequired
}, _temp)) || _class) || _class) || _class);
var _default = NewMedicalApplicationModal;
exports.default = _default;
;

(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;

  if (!reactHotLoader) {
    return;
  }

  reactHotLoader.register(NewMedicalApplicationModal, 'NewMedicalApplicationModal', '/app/src/components/page-case/main-applications/NewMedicalApplicationModal.js');
  reactHotLoader.register(_default, 'default', '/app/src/components/page-case/main-applications/NewMedicalApplicationModal.js');
})();

;

(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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